// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video-graphic[data-v-388017a8]{position:relative;min-height:48px;padding:0 4px}.video-graphic .character[data-v-388017a8]{margin-top:5px;padding-bottom:10px;color:#2b3439;font-weight:500;font-size:13px;line-height:18px}.video-graphic .graphic-avatar[data-v-388017a8]{width:24px;height:24px;margin-right:5px;border-radius:50%}", ""]);
// Exports
module.exports = exports;
